"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skLocaleData = require("i18next-icu/locale-data/sk");
exports.default = skLocaleData;
//# sourceMappingURL=sk.js.map